import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import type { FunctionComponent } from 'react';

export const PageLoadingSpinner: FunctionComponent = () => (
    <Box
        sx={{
            alignItems: 'center',
            backgroundColor: 'transparent',
            display: 'flex',
            gap: 2,
            height: '80vh',
            justifyContent: 'center',
            margin: 'auto',
        }}
    >
        <CircularProgress />
    </Box>
);

export const TableLoadingSpinner: FunctionComponent = () => (
    <Box
        sx={{
            alignItems: 'center',
            backgroundColor: 'transparent',
            display: 'flex',
            height: '100%',
            justifyContent: 'center',
            margin: 'auto',
        }}
    >
        <CircularProgress />
    </Box>
);

export const InlineLoadingSpinner: FunctionComponent = () => (
    <Box
        className="inline-loading-spinner"
        sx={{
            alignItems: 'center',
            backgroundColor: 'transparent',
            display: 'flex',
            justifyContent: 'center',
            margin: 'auto',
            padding: 1,
        }}
    >
        <CircularProgress />
    </Box>
);
